import { DEFAULT_TILES_PER_ROW } from 'LayoutBuilderUI/components/panels/sidebar/utils/sizing';
export const getTooltipPlacement = index => {
  return index % DEFAULT_TILES_PER_ROW < 2 ? 'top right' : 'top left';
};